import { createFileRoute } from '@tanstack/react-router'
import EditionContainer from 'Edition/containers/EditionContainer'
import { editionQueries } from 'Edition/utils/queries'
import { claimTypesEnum } from 'User/utils/claims'

import { PageSkeleton } from 'Common/components/skeletons'

import { Guard } from '../../../-guard'
import { prefetchWhenAuthenticated } from '../../../-prefetch'

export const Route = createFileRoute('/work/$workId_/edition/$editionId')({
    loader: ({ context, params }) =>
        prefetchWhenAuthenticated(
            context.queryClient,
            editionQueries.detail(Number(params.editionId)),
        ),
    pendingComponent: () => <PageSkeleton variant="detail" />,
    component: () => (
        <Guard claims={[claimTypesEnum.enum.opus_work]}>
            <EditionContainer />
        </Guard>
    ),
})
